//
// Copyright 2026 DXOS.org
//
import * as Rpc from '@effect/rpc/Rpc';
import * as RpcGroup from '@effect/rpc/RpcGroup';
import * as Context from 'effect/Context';
import { protoMessage, serviceError } from './service-rpc.js';
/**
 * Effect RPC definitions for `dxos.client.services.ContactsService`.
 * Shared proto types remain protobuf-encoded on the wire.
 */
export class Rpcs extends RpcGroup.make(Rpc.make('getContacts', {
    success: protoMessage('dxos.client.services.ContactBook'),
    error: serviceError,
}), Rpc.make('queryContacts', {
    success: protoMessage('dxos.client.services.ContactBook'),
    error: serviceError,
    stream: true,
})).prefix('ContactsService.') {
}
/**
 * Effect service tag for the `ContactsService` RPC handlers.
 */
export class Tag extends Context.Tag('@dxos/protocols/rpc/ContactsService')() {
}
//# sourceMappingURL=ContactsService.js.map